import { useMediaQuery } from "@chakra-ui/react";
import { useRecoilState, useRecoilValue } from "recoil";
import Fade from "../../components/Fade";
import { selectionAtom } from "../../store/selection.atom";
import { titles } from "../../store/title.atome";
import { visibilityAtom } from "../../store/visibility";

const MainViewHeader = () => {
  const [selection] = useRecoilState(selectionAtom);
  const [, setVisibility] = useRecoilState(visibilityAtom);
  const [isMedium] = useMediaQuery(["(min-width: 768px)"]);
  const { main_text } = useRecoilValue(titles);

  return (
    <Fade
      isVisible={!selection.category || isMedium}
      onExitComplete={() =>
        setVisibility((prev) => ({
          ...prev,
          showCategories: false,
          showBlog: false,
          showMainHeader: false,
          showTitles: true,
        }))
      }
    >
      <div className={`flex h-[103px] flex-col gap-1 p-5`}>
        <h3 className="text-xl font-semibold leading-[25px] text-rss-primary-color">
          RSS FEED
        </h3>
        <p className="line-clamp-2 text-sm leading-[17px] text-rss-gray">
          {main_text}
        </p>
      </div>
    </Fade>
  );
};

export default MainViewHeader;
